
import request from '../request'
//用户管理
 export function userSearch(params,data) { //搜索用户
    return request({
        url: "/user/search",
        method: "get",
        params,
        data
    })  
}

export function userDelete(id){ //删除用户
    return request({
        url:`/user/delete/${id}`,
        method: "post",
    })
}
export function pwdReset(id){ //重置密码
    return request({
        url: `/user/reset/${id}`,
        method: "post"
    })
} 
export function userRegister(params,data){ //注册用户
    return request({
        url: "/user/register",
        method: "get",
        params,
        data
    })
}
export function userFreeze(id,status){ //冻结用户
    return request({
        url: `/user/freeze/${id}/${status}`,
        method: "get",
    })
}
export function userLevel(type){ //查询等级
    return request({
        url: `/user/level/${type}`,
        method: "get",
    })
} 
//给用户添加角色
export function roleForUser(userId){ //查询角色
    return request({
        url: `/role/list_all_by/user?userId=${userId}`,
        method: "get",
    })
}
//角色管理
export function roleSearch(params,data){ //查询角色
    return request({
        url: `/role/search`,
        method: "get",
        params,
        data
    })
}
export function roleSave(params,data){ //添加角色
    return request({
        url: `/role/save`,
        method: "post",
        params,
        data
    })
} 
export function roleIdMenuList(id){ //根据用户id查询菜单
    return request({
        url: `/menu/list/role/${id}`,
        method: "get",
    })
} 
export function roleUpdate(params,data){ //修改角色
    return request({
        url: `/role/update`,
        method: "post",
        params,
        data
    })
} 
export function roleDelete(id){ //删除角色
    return request({
        url: `/role/delete/${id}`,
        method: "post",
    })
}
export function roleLink(data){ //更新用户角色关联关系
    return request({
        url: `/user/update_user_role`,
        method: "post",
        data
    })
}
//操作日志
export function operatelogSearch(params){ //操作日志分页查询
    return request({
        url: `/operatelog/search`,
        method: "get",
        params
    })
}